import AbstractCountrySelect from './AbstractCountry';
import { getCountryName } from '../../helpers/countryNames';
import { OECDDonors } from '../../helpers/oecdCountries';

const selectOptions = (function buildOptions() {
  return OECDDonors.map(code => ({
    value: code,
    label: getCountryName(code)
  }));
})();

class DonorCountrySelect extends AbstractCountrySelect {
  name = "donor-select-list";

  getOptions() {
    return selectOptions;
  }
}

export default DonorCountrySelect;



// WEBPACK FOOTER //
// ./src/components/Selects/DonorCountry.js